import React from 'react';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import Icon from '../../../../../../CommonComponents/Icon';
import { PositionsDTO } from '../GainLossMobile.meta';

interface Props {
  positions: PositionsDTO[];
  setPositionMobile(data: PositionsDTO): void;
}

export const PositionsListMobile = ({ positions, setPositionMobile }: Props) => {
  return (
    <tr>
      <td colSpan={2} style={{ padding: 0 }}>
        <HtmlTable width="100%">
          <table>
            <tbody>
              {positions.map(pos => (
                <tr
                  key={pos.name}
                  onClick={() =>
                    setPositionMobile({
                      ...pos,
                    })
                  }
                >
                  <td>
                    <Box display="flex" justifyContent="space-between">
                      <Text
                        fontWeight={600}
                        color="neutral.700"
                        textAlign="left"
                        maxWidth={300}
                        isTruncated
                      >
                        {pos.name}
                      </Text>
                      <Icon className="far fa-chevron-right" color="neutral.500" />
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </HtmlTable>
      </td>
    </tr>
  );
};
